<script lang="ts" setup>
import type { DynamicItemSlider } from '@autobid/strapi-integration/rest/components'
import { SLIDER_RECOMMENDATION_KEY } from '@autobid/ui/constants/CAR_SLIDER_KEYS'
import { useQuery } from '@tanstack/vue-query'
import { onServerPrefetch } from 'vue'
import ItemSliderInner from './ItemSliderInner.vue'

const props = defineProps<DynamicItemSlider>()
const { $trpc } = useNuxtApp()

const { data, suspense } = useQuery({
  queryKey: [SLIDER_RECOMMENDATION_KEY],
  queryFn: async () => {
    try {
      return await $trpc.webapi.getRecommendedCars.query({
        perPage: props.itemsCount,
      })
    }
    catch {
      return null
    }
  },
})

onServerPrefetch(suspense)
</script>

<template>
  <ItemSliderInner v-if="data?.length" v-bind="props" :ids="data" />
</template>
